import { useEffect, useRef, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useSelector } from "react-redux";
import { dataUpload } from "../../connections/dataUpload";
import { downloadTemplate } from "../../connections/downloadTemplate";
import Select from "react-select";
import { getCheckUploadStatus } from "../../connections/getCheckUploadStatus";
import JobStatusModal from "./JobStatusModal";
import DataExport from "./DataExport";
import JobStatusTable from "./JobStatusTable";

// all types
// const types = [
//     { label: "Taggings", value: "tagging" },
//     { label: "Ipd Staff Duty Rosters", value: "ipd_staff_duty_roster" },
//     { label: "Ipd Departments", value: "ipd_department" },
//     { label: "Ipd Admissions", value: "ipd_admission" },
//     { label: "Abdm Api Logs", value: "abdm_api_log" },
//     { label: "Ipd Documents", value: "ipd_document" },
//     { label: "Ipd Discharge Medications", value: "ipd_discharge_medication" },
//     { label: "Ipd Visits", value: "ipd_visit" },
//     { label: "Ipd Discharge Summaries", value: "ipd_discharge_summary" },
//     { label: "Ipd Admission Charges", value: "ipd_admission_charge" },
//     { label: "Ipd Assessments", value: "ipd_assessment" },
//     { label: "Ipd Reports", value: "ipd_report" },
//     { label: "Ipd Locations Staff Duty Rosters", value: "ipd_locations_staff_duty_roster" },
//     { label: "Ipd General Instructions", value: "ipd_general_instruction" },
//     { label: "Ipd Discharge Process Checklists", value: "ipd_discharge_process_checklist" },
//     { label: "Ipd Process Checklists", value: "ipd_process_checklist" },
//     { label: "Diagnoses", value: "diagnose" },
//     { label: "Field Inputs", value: "field_input" },
//     { label: "Consumables Medical Tests", value: "consumable_medical_test" },
//     { label: "Field Input Options", value: "field_input_option" },
//     { label: "Consumables", value: "consumable" },
//     { label: "Educations", value: "education" },
//     { label: "Generic Reminders", value: "generic_reminder" },
//     { label: "Feedbacks", value: "feedback" },
//     { label: "Followup Lists", value: "followup_list" },
//     { label: "Departments", value: "department" },
//     { label: "Feedback Templates", value: "feedback_template" },
//     { label: "Active Storage Blobs", value: "active_storage_blob" },
//     { label: "Active Admin Comments", value: "active_admin_comment" },
//     { label: "Accounts", value: "account" },
//     { label: "Admissions", value: "admission" },
//     { label: "Appointment Slots", value: "appointment_slot" },
//     { label: "Admin Users", value: "admin_user" },
//     { label: "Account Pharmacies", value: "account_pharmacy" },
//     { label: "Active Storage Attachments", value: "active_storage_attachment" },
//     { label: "Appointments Medical Tests", value: "appointment_medical_test" },
//     { label: "Ar Internal Metadata", value: "ar_internal_metadata" },
//     { label: "Backops Users", value: "backops_user" },
//     { label: "Backops Users Roles", value: "backops_user_role" },
//     { label: "Cities", value: "city" },
//     { label: "Consumable Categories", value: "consumable_category" },
//     { label: "Appointments", value: "appointment" },
//     { label: "Holidays", value: "holiday" },
//     { label: "Labs", value: "lab" },
//     { label: "Lab Inventories", value: "lab_inventory" },
//     { label: "Medical Test Reports", value: "medical_test_report" },
//     { label: "Lab Inventories Medical Tests", value: "lab_inventory_medical_test" },
//     { label: "Master Reminders", value: "master_reminder" },
//     { label: "Lab Inventory Stocks", value: "lab_inventory_stock" },
//     { label: "Medical Test Categories", value: "medical_test_category" },
//     { label: "Medical Test Shortcodes", value: "medical_test_shortcode" },
//     { label: "Medical Test Shortcodes Tests", value: "medical_test_shortcode_test" },
//     { label: "Invoices", value: "invoice" },
//     { label: "Generic Reports", value: "generic_report" },
//     { label: "Invoice Items", value: "invoice_item" },
//     { label: "Occupations", value: "occupation" },
//     { label: "Medicine Salts", value: "medicine_salt" },
//     { label: "Medicine Batches", value: "medicine_batch" },
//     { label: "Medical Tests", value: "medical_test" },
//     { label: "Medicine Remarks", value: "medicine_remark" },
//     { label: "Organizations", value: "organization" },
//     { label: "Organization Accounts", value: "organization_account" },
//     { label: "Organization Settings", value: "organization_setting" },
//     { label: "Otp Logs", value: "otp_log" },
//     { label: "Medicine Descriptions", value: "medicine_description" },
//     { label: "Permissions", value: "permission" },
//     { label: "Permissions Roles", value: "permission_role" },
//     { label: "Queries", value: "query" },
//     { label: "Prescriptions", value: "prescription" },
//     { label: "Responses", value: "response" },
//     { label: "Purchase Items", value: "purchase_item" },
//     { label: "Pharmacies", value: "pharmacy" },
//     { label: "Reminders", value: "reminder" },
//     { label: "Referrers", value: "referrer" },
//     { label: "Revenue Shares", value: "revenue_share" },
//     { label: "Roles Specialists", value: "role_specialist" },
//     { label: "Schema Migrations", value: "schema_migration" },
//     { label: "Roles", value: "role" },
//     { label: "Specialist Medical Tests", value: "specialist_medical_test" },
//     { label: "Specialists", value: "specialist" },
//     { label: "Treatments", value: "treatment" },
//     { label: "Special Instructions", value: "special_instruction" },
//     { label: "Suppliers", value: "supplier" },
//     { label: "Versions", value: "version" },
//     { label: "Treatment Medicines", value: "treatment_medicine" },
//     { label: "Specialist Plans", value: "specialist_plan" },
//     { label: "Video Categories", value: "video_category" },
//     { label: "Query Replies", value: "query_reply" },
//     { label: "Feedback Questions", value: "feedback_question" },
//     { label: "Active Storage Variant Records", value: "active_storage_variant_record" },
//     { label: "Videos", value: "video" },
//     { label: "Medicines", value: "medicine" },
//     { label: "Push Tokens", value: "push_token" },
//     { label: "Notifications", value: "notification" },
//     { label: "Ipd Nursing Hand Over Sheets", value: "ipd_nursing_hand_over_sheet" },
//     { label: "Appointment Matrices", value: "appointment_matrice" },
//     { label: "Daily Health Records", value: "daily_health_record" },
//     { label: "Ipd Job Requests", value: "ipd_job_request" },
//     { label: "Ipd Medications", value: "ipd_medication" },
//     { label: "Ipd Mrd Checklists", value: "ipd_mrd_checklist" },
//     { label: "Ipd Vitals Input Outputs", value: "ipd_vitals_input_output" },
//     { label: "Ipd Notes", value: "ipd_note" },
//     { label: "Ipd Cross Consultations", value: "ipd_cross_consultation" },
//     { label: "External Doctors", value: "external_doctor" },
//     { label: "Medicine Packings", value: "medicine_packing" },
//     { label: "Patients", value: "patient" },
//     { label: "Abha Infos", value: "abha_info" },
//     { label: "Purchase Orders", value: "purchase_order" },
//     { label: "Ipd Shortcodes", value: "ipd_shortcode" },
//     { label: "Ipd Medication Administration Records", value: "ipd_medication_administration_record" },
//     { label: "Ipd Suggested Medical Tests", value: "ipd_suggested_medical_test" },
//     { label: "Ipd Fluid Mixes", value: "ipd_fluid_mix" },
//     { label: "Ipd Report Files", value: "ipd_report_file" },
//     { label: "Ipd Locations", value: "ipd_location" },
//     { label: "Ipd Bed Assignments", value: "ipd_bed_assignment" },
//     { label: "Batch Infos", value: "batch_info" }
// ];

const types = [{ label: "Medicines", value: "medicine" }];

const DataImport = () => {
  const {
    user: { user },
  } = useSelector((store) => store);

  const [activeTab, setActiveTab] = useState("import");
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");
  const [selectedTypes, setSelectedTypes] = useState("");
  const [isUploading, setIsUploading] = useState(false); // 🚫 disable upload
  const [jobId, setJobId] = useState(null);

  const [showModal, setShowModal] = useState(false);

  console.log(selectedTypes, "selectedTypes");
  const pollingInterval = useRef(null);

  // const handleFileUpload = async () => {
  //     if (!selectedFile) {
  //         setUploadStatus("Please select a file first!");
  //         return;
  //     }

  //     const formData = new FormData();
  //     formData.append("type", "medicine");
  //     formData.append("file", selectedFile);

  //     setUploadStatus("Uploading...⏳");

  //     const res = await dataUpload(user?.token, formData);

  //     if (res) {
  //         setUploadStatus("✅ File uploaded successfully!");
  //         setSelectedFile(null);
  //     } else {
  //         setUploadStatus("❌ Upload failed!");
  //     }
  // };

  // console.log(selectedTypes, 'selectedTypes');

  const handleFileUpload = async () => {
    if (!selectedFile) {
      return setUploadStatus("Please select a file first!");
    }

    // if (isUploading) {
    //     return toast.warning("A job is already running. Please wait!");
    // }

    try {
      const formData = new FormData();
      formData.append("type", selectedTypes?.value || "medicine");
      formData.append("file", selectedFile);

      setUploadStatus("Uploading... ⏳");
      // setIsUploading(true);

      const res = await dataUpload(
        user?.token,
        formData,
        selectedTypes?.value?.toString(),
      );
      console.log(res, "upload response");

      if (res?.job_id) {
        setJobId(res.job_id);
        setUploadStatus("");
        // setUploadStatus("Job started... waiting for completion 🕐");
        // startPolling(res.job_id); // 👇 start checking status
      } else {
        setUploadStatus("❌ Upload failed to start job!");
        setIsUploading(false);
      }
    } catch (err) {
      setUploadStatus("❌ Something went wrong!");
      setIsUploading(false);
    }
  };

  // 🧩 polling logic
  // const startPolling = (jobId) => {
  //     pollingInterval.current = setInterval(async () => {
  //         try {
  //             const statusRes = await getCheckUploadStatus(user?.token, jobId);
  //             console.log("Polling:", statusRes);

  //             if (statusRes?.status === "done") {
  //                 clearInterval(pollingInterval.current);
  //                 setUploadStatus("✅ Job completed successfully!");
  //                 setIsUploading(false);
  //                 setSelectedFile(null);
  //             } else if (statusRes?.status === "failed") {
  //                 clearInterval(pollingInterval.current);
  //                 setUploadStatus("❌ Job failed!");
  //                 setIsUploading(false);
  //             }
  //         } catch (error) {
  //             clearInterval(pollingInterval.current);
  //             setUploadStatus("❌ Error while checking job status!");
  //             setIsUploading(false);
  //         }
  //     }, 4000); // every 5 seconds
  // };

  // 🧹 cleanup when component unmounts
  useEffect(() => {
    return () => {
      if (pollingInterval.current) clearInterval(pollingInterval.current);
    };
  }, []);

  return (
    <>
      <Header />
      <Sidebar activeClassName="data-import" />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Data Import / Export</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">
                    Data Import / Export
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-white w-100 p-3 rounded">
            {/* Tabs */}
            <div className="row">
              <div className="card mb-2">
                <div className="card-body">
                  <ul className="nav nav-tabs">
                    <li className="nav-item">
                      <button
                        type="button"
                        className={`nav-link ${activeTab === "import" ? "active" : ""}`}
                        onClick={() => setActiveTab("import")}
                      >
                        Import
                      </button>
                    </li>

                    <li className="nav-item">
                      <button
                        type="button"
                        className={`nav-link ${activeTab === "export" ? "active" : ""}`}
                        onClick={() => setActiveTab("export")}
                      >
                        Export
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Import Section */}
            {activeTab === "import" && (
              <div className="card card-table show-entire">
                <div className="card-body">
                  {/* <div className="page-table-header mb-1">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Data Import / Export</h3>
                          <div className="doctor-search-blk" />
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      className="p-0 mt-2"
                      style={{
                        flex: "0 0 70%",
                        minWidth: "200px",
                        display: "flex",
                      }}
                    >
                      <div
                        className="form-group local-forms"
                        style={{ width: "100%" }}
                      >
                        <label>
                          Select Type <span className="login-danger">*</span>
                        </label>

                        <Select
                          isSearchable
                          placeholder="Choose option"
                          value={selectedTypes}
                          onChange={(selected) => setSelectedTypes(selected)}
                          options={types}
                          className="react-select"
                          classNamePrefix="select"
                          menuPortalTarget={document.body}
                          styles={{
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                            menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                            control: (base, state) => ({
                              ...base,
                              borderColor: state.isFocused
                                ? "#2e37a4"
                                : "rgba(46, 55, 164, 0.1)",
                              boxShadow: state.isFocused
                                ? "0 0 0 1px #2e37a4"
                                : "none",
                              borderRadius: "10px",
                              fontSize: "14px",
                              minHeight: "50px",
                              height: "50px",
                              width: "100%",
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              transition: "250ms",
                              height: "35px",
                            }),
                            container: (base) => ({ ...base, width: "100%" }),
                          }}
                        />
                      </div>
                    </div>

                    {/* <div
                      className="p-4 mb-3"
                      style={{
                        flex: "0 0 30%",
                        minWidth: "200px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="btn btn-outline-primary px-3"
                        style={{ height: 40 }}
                        onClick={() => setShowModal(true)}
                      >
                        <FeatherIcon
                          icon="activity"
                          size={16}
                          className="me-2"
                        />
                        Job Status
                      </button>
                    </div> */}
                  </div>

                  {/* <JobStatusModal
                    show={showModal}
                    handleClose={() => setShowModal(false)}
                    token={user?.token}
                  /> */}

                  {selectedTypes && (
                    <div className="import-section mt-1 p-4 border rounded">
                      <h5 className="mb-3">
                        {selectedTypes?.label || ""} Data Template Download
                      </h5>

                      <div className="d-flex align-items-center gap-3 mb-3">
                        <button
                          className="btn btn-primary submit-form"
                          onClick={() =>
                            downloadTemplate(user?.token, selectedTypes?.value)
                          }
                        >
                          📥 Download Template
                        </button>
                      </div>

                      <div className="import-section mt-4 p-4 border rounded">
                        <h5 className="mb-3">
                          {selectedTypes?.label || ""} Data Upload
                        </h5>

                        <div className="d-flex align-items-center gap-3 mb-3">
                          <input
                            type="file"
                            accept=".csv"
                            onChange={(e) =>
                              setSelectedFile(e.target.files?.[0] || null)
                            }
                            className="form-control"
                            style={{ maxWidth: "300px" }}
                          />

                          <button
                            className="btn btn-primary submit-form"
                            onClick={handleFileUpload}
                            disabled={!selectedFile || isUploading}
                          >
                            {isUploading ? "Uploading..." : "Upload File"}
                          </button>
                        </div>

                        {uploadStatus && (
                          <p className="mt-2 text-primary">{uploadStatus}</p>
                        )}
                      </div>
                    </div>
                  )}

                  {selectedTypes && (
                    <JobStatusTable
                      token={user?.token}
                      jobId={jobId}
                      type={selectedTypes?.value}
                    />
                  )}

                  {/* {selectedTypes && (
                    <div className="import-section mt-4 p-4 border rounded">
                      <h5 className="mb-3">
                        {selectedTypes?.label || ""} Data Upload
                      </h5>

                      <div className="d-flex align-items-center gap-3 mb-3">
                        <input
                          type="file"
                          accept=".csv"
                          onChange={(e) =>
                            setSelectedFile(e.target.files?.[0] || null)
                          }
                          className="form-control"
                          style={{ maxWidth: "300px" }}
                        />

                        <button
                          className="btn btn-primary submit-form"
                          onClick={handleFileUpload}
                          disabled={!selectedFile || isUploading}
                        >
                          {isUploading ? "Uploading..." : "Upload File"}
                        </button>
                      </div>

                      {uploadStatus && (
                        <p className="mt-2 text-primary">{uploadStatus}</p>
                      )}
                    </div>
                  )} */}
                </div>
              </div>
            )}

            {activeTab === "export" && <DataExport />}
          </div>
        </div>
      </div>
    </>
  );
};

export default DataImport;
